import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import useTranslate from '../../../../localization/helpers';
var DetailedPermissions = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var translate = useTranslate().translate;
    return (_jsxs(Dialog, { open: isOpen, onClose: onClose, maxWidth: 'md', children: [_jsx(DialogTitle, { children: translate('roles.detailedPermissions') }), _jsx(DialogContent, { children: _jsx(TableContainer, { component: Paper, style: { boxShadow: '0 24px 48px 0 #919EAB29' }, children: _jsxs(Table, { sx: { minWidth: 650 }, "aria-label": 'detailed permissions table', children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: translate('roles.permission') }), _jsx(TableCell, { children: translate('roles.enable') })] }) }), _jsx(TableBody, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { component: 'th', scope: 'row', children: translate('roles.permissions') }), _jsx(TableCell, { children: _jsx(Switch, { checked: false }) })] }) })] }) }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: onClose, variant: 'outlined', sx: {
                        fontSize: '16px',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '16px',
                        border: '1px solid #919EAB52',
                        color: '#161C24',
                        '&:hover': {
                            backgroundColor: '#FFFFFF',
                            color: '#161C24',
                            '& .MuiSvgIcon-root': {
                                color: '#161C24'
                            }
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#161C24'
                        }
                    }, children: translate('actions.close') }) })] }));
};
export default DetailedPermissions;
